/**
 * Graphology Diameter
 * ========================
 *
 * Functions used to compute the diameter of the given graph.
 */
var isGraph = require('graphology-utils/is-graph');
var eccentricity = require('./eccentricity.js');

module.exports = function diameter(graph) {
  if (!isGraph(graph))
    throw new Error(
      'graphology-metrics/diameter: given graph is not a valid graphology instance.'
    );

  if (graph.size === 0) return Infinity;

  var D = -Infinity,
    ecc = 0;
  var nodes = graph.nodes();

  for (var i = 0, l = nodes.length; i < l; i++) {
    ecc = eccentricity(graph, nodes[i]);
    if (ecc > D) D = ecc;
    if (D === Infinity) break;
  }

  return D;
};
